import useKeyboardAccessibility from "@/components/hooks/useKeyboardAccessibility";
import {RootState} from "@/reducers/store";
import _ from "lodash";
import {FC,useEffect,useReducer,useRef,useState} from "react";
import {useSelector} from "react-redux";
import {FormValues} from "../../SurveyModel/types/commonTypes";

interface IProps {
    type: "primary" | "secondary" | "tertiary";
    stateProp: "enabled" | "pressed" | "focus" | "hover" | "disabled";
    icon: boolean;
    text: string;
    handleClick: ()=> void
}

const ACTIONS = {
    MOUSE_ENTER: "mouse_enter",
    MOUSE_LEAVE: "mouse_leave",
    DATA_ENTERED: "data_entred",
    DATA_NOT_AVAILABLE: 'data_not_available',
    CLICK: "click",
};

function reducer(state: any, action: string) {
    switch (action) {
        case ACTIONS.MOUSE_ENTER:
            return { ...state, state: "hover",  mouseState: "enter"  };
        case ACTIONS.MOUSE_LEAVE:
            return { ...state, mouseState: "left" };
        case ACTIONS.DATA_ENTERED:
            return { ...state, state: "enabled", mouseState: "left" };
        case ACTIONS.DATA_NOT_AVAILABLE:
                return { ...state, state: "disabled", mouseState: "left" };
        case ACTIONS.CLICK:
            if(state.state === 'enabled')
                return { ...state, state: "pressed" };
            return state 
        default:
            return state;
    }
}

const SaveButton: FC<IProps> = ({ type, stateProp, icon, text, handleClick  }: IProps): JSX.Element => {


    const { currentQuestion } = useSelector((state:RootState) => state.patientSurvey);
    const form = useSelector((state:RootState) => state.form);
    const [localFieldValue, setLocalFieldValue] = useState<FormValues>();
    const [questionName, setQuestionName] = useState('') 
    const [state, dispatch] = useReducer(reducer, {
        type: type || "primary",
        state: stateProp || "enabled",
        mouseState: '',
        icon: icon || false,
    });

    const ref = useRef<HTMLDivElement>(null);

    const handleKeyPress = () => {
        if (state.state === "enabled") handleClick();
      };

      useKeyboardAccessibility(ref, handleKeyPress);

    useEffect(()=>{
        if(currentQuestion && questionName != currentQuestion.name ){
            setQuestionName(currentQuestion.name);
            dispatch(ACTIONS.DATA_NOT_AVAILABLE)
            if( form[currentQuestion.name]){
                setLocalFieldValue(form[currentQuestion.name].value)
            }
  
        }
    }, [currentQuestion, form, questionName])

    const compareValues = (value1: FormValues, value2: FormValues) => {
        return _.isEqual(value1, value2)
    }

    useEffect(()=>{
        if(currentQuestion && questionName === currentQuestion.name&& currentQuestion && form[currentQuestion.name] && !compareValues(localFieldValue,form[currentQuestion.name].value ) ){
            dispatch(ACTIONS.DATA_ENTERED);
            setLocalFieldValue(form[currentQuestion.name].value)
        }

    },[ currentQuestion, localFieldValue, form, state])

    return (
        <div
            role="button"
            ref={ref}
            tabIndex={0}
            onTouchStart={() => {
                if(state.state !== 'disabled'){
               dispatch(ACTIONS.MOUSE_ENTER)
           } 
       }}
            onTouchEnd={() => {
                if(state.state !== 'disabled')
                    dispatch(ACTIONS.MOUSE_LEAVE)}}
            className={`save-button ${state.state} ${state.type}`}
            onMouseEnter={() => {
                     if(state.state !== 'disabled'){
                    dispatch(ACTIONS.MOUSE_ENTER)
                } 
            }}
            onMouseLeave={() => {
                if(state.state !== 'disabled')
                    dispatch(ACTIONS.MOUSE_LEAVE)}
            } 
            onClick={() => {
                dispatch(ACTIONS.CLICK);
                if(state.state !== "disabled")
                    handleClick()
            }}
        >
            <div className={`outer state-${state.state} mouse-${state.mouseState} type-${state.type} icon-${state.icon}`}>
                {state.state !== "disabled" && (
                    <div className="inner">
                        <div className="next">
                            {!state.icon ? text : <div className="text-wrapper">{text}</div>}
                        </div>
                    </div>
                )}
                 {state.state === "disabled" && (
                    <div className="inner">
                        <div className="next">
                            {!state.icon ? text : <div className="text-wrapper">{text}</div>}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SaveButton;
